<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Checkout' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="success-section mt-5">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h1>Order Confirmed</h1>
                <p class="successParagraph">Thank you! Your order has been placed successfully</p>
                <img src="../../../../assets/img/home2/box.png" class="itemImage" width="220" alt="success">
                <p><a href="menu" class="btn btn-primary">Continue Shopping</a></p>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>